import { InternalTransactionPairingType } from '@g2-shared/api-client/generated/till-app';

export const InternalTransactionPairingTypeOptions = {
  [InternalTransactionPairingType.DONT_PAIR]: "Don't pair",
  [InternalTransactionPairingType.PAIR]: 'Pair',
};
